import React from "react";
import StudentCard from "./generate";  // Import the StudentCard component

const View = ({ students }) => {
  return (
    <div className="view-container">
      <h2>Student Cards</h2>
      {students.length > 0 ? (
        <div className="view-list">
          {students.map((student, index) => (
            <div key={index} className="view-item">
              <h3>{student.Names}</h3>
              <StudentCard student={student} />
            </div>
          ))}
        </div>
      ) : (
        <p>No student data available.</p>
      )}
    </div>
  );
};

export default View;
